/*
* Component counts page views and prompts login if not logged in.
*/
<template>

</template>

<script>
	import ls from 'localstorage-slim';
	import AuthMixins from '@/mixins/AuthMixins';

  export default {
    name: 'SignInPrompt',

    mixins: [AuthMixins],

   	data() {
      return {
				url:'',
				dwellSeconds: 20,
        maxPageViews: 3,
        isLoading: false,
				timeoutID: 0
      }
    },

		created() {
			this.url = window.location.pathname;
			this.emitter.on("removeSignInPromptTimeout",this.removeSignInPromptTimeout)
		},

    mounted() {
			if (!this.me) {
				if (!this.is_search_page) {
					this.startDwellTimer();
				}
				this.incrementPageView();
      } else {
        ls.remove('prompt');

				if (this.me['onboard-complete'] !== true) {
					this.emitter.emit("openModal", { name: 'SignIn', message: false, persistent: true, mode: 'onboard' });
				}
      }
    },

    methods: {
      incrementPageView() {
				let pages = ls.get('prompt', { decrypt: true });
				console.log({pages});
				if (pages == null) {
					pages = [];
					ls.set('prompt', pages, { encrypt: true });
					clearTimeout(this.timeoutID);
				} else if (pages.length >= this.maxPageViews) {
					this.showPrompt();
				} else if (!pages.includes(window.location.pathname)) {
					pages.push(window.location.pathname);
					ls.set('prompt', pages, { encrypt: true });
				}
      },
			startDwellTimer() {
				this.timeoutID = setTimeout(() => {
					this.showPrompt();
				}, this.dwellSeconds * 1000);
			},
			showPrompt() {        
        if (!document.getElementById('modal')) {         
          this.emitter.emit("openModal", { name: 'SignIn', message: true, persistent: true, mode: 'join' });
        }        
        clearTimeout(this.timeoutID);
        ls.remove('prompt');
			},
			removeSignInPromptTimeout() {
				this.$nextTick(() => {
					clearTimeout(this.timeoutID);
				})
			}
    },
		computed: {
			is_search_page() {
				let searches = [
					'/search/jobs',
					'/search/discover',
					'/search/organisations',
					'/search/saved',
					'/courses',
					'/resources',
					'/events'
				];
				return searches.includes(this.url);
			}
		}
  };
</script>
